import lock from '../images/main/ourValue/lock.svg'
import cup from '../images/main/ourValue/cup.svg'
import rings from '../images/main/ourValue/rings.svg'
import { HashRouter, generatePath } from 'react-router-dom'

export const ourValue = [
  {
    id: 1,
    title: 'Профессионализм и ответственность',
    img: lock,
    text: 'Мы ведём бизнес честно с соблюдением служебных этических норм. Наши действия соответствуют высоким стандартам профессионализма, а прозрачность процессов является основой доверия со стороны сотрудников и партнёров.'
  },
  {
    id: 2,
    title: 'Опора на передовые научные достижения',
    img: cup,
    text: 'Мы постоянно изучаем мировую практику в индустрии и стремимся реализовывать лучшие известные подходы в работе, внедряем передовые практики и технологии, обладаем уникальной экспертизой и компетенциями.'
  },
  {
    id: 3,
    title: 'Командный подход',
    img: rings,
    text: 'Мы объединены общей целью, вдохновляя друг друга на достижение высоких результатов. В процессе решения сложных задач учитываем различные мнения и подходы, стремимся к конструктивному диалогу и принятию взвешенных решений.'
  }
]
